import { Navigate, Route, Routes } from "react-router-dom";
import { useMe } from "./hooks/useApi";
import { LoginScreen } from "./components/LoginScreen";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { RideDetailPage } from "./pages/RideDetailPage";

function FullscreenSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-brand-600" />
    </div>
  );
}

export default function App() {
  const { data: user, isLoading, isError } = useMe();

  if (isLoading) return <FullscreenSpinner />;
  if (isError || !user) return <LoginScreen />;

  return (
    <AppShell user={user}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/rides/:id" element={<RideDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
